import { useAuthStore } from '@/store/authStore';
import { Tenant } from '@/types';

export interface UseTenantReturn {
  tenant: Tenant | null;
  isSuperAdmin: boolean;
  tenantName: string;
  tenantLogo: string | null;
  tenantColor: string;
}

export function useTenant(): UseTenantReturn {
  const tenant = useAuthStore((state) => state.tenant);
  const isSuperAdmin = useAuthStore((state) => state.isSuperAdmin);

  const tenantName = tenant?.nome ?? 'TASK CRM';
  const tenantColor = tenant?.cor_primaria ?? '#2563EB';
  const tenantLogo = tenant?.logo_url ?? null;

  return {
    tenant,
    isSuperAdmin,
    tenantName,
    tenantLogo,
    tenantColor,
  };
}
